import { render, staticRenderFns } from "./CookieBarComponent.vue?vue&type=template&id=ae5b5bf2&scoped=true"
import script from "./CookieBarComponent.vue?vue&type=script&lang=js"
export * from "./CookieBarComponent.vue?vue&type=script&lang=js"
import style0 from "./CookieBarComponent.vue?vue&type=style&index=0&id=ae5b5bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5b5bf2",
  null
  
)

export default component.exports